import { FunctionComponent, ReactNode } from 'react'
import styled, { css } from 'styled-components'

const StyledPromoLabel = styled.div`
  ${({
    theme: {
      fonts: { goodOT },
      colors: {
        white,
        grey: { grey_100 },
      },
    },
  }) => {
    return css`
      display: inline-block;
      color: ${white};
      text-transform: uppercase;
      font-size: 12px;
      font-weight: 500;
      letter-spacing: 2px;
      line-height: 1;
      text-shadow: 0 0 8px ${grey_100}, 0 0 8px ${grey_100};
      padding: 0;
      font-family: ${goodOT}, 'Arial Narrow', Impact;
      margin-bottom: 10px;
    `
  }}
`

const PromoLabel: FunctionComponent<{ children?: ReactNode }> = ({
  children,
}) => <StyledPromoLabel>{children}</StyledPromoLabel>

export default PromoLabel
